import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

export interface CustomerReview {
    id: number;
    name: string;
    avatar: string;
    date: string;
    rating: number;
    comment: string;
    service: string;
    title?: string;
    verified?: boolean;
    likes?: number;
    hasLiked?: boolean;
}

@Component({
    selector: 'app-review',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

    screenWidth: number = 1200;

    // Filter & Search states
    selectedCategory: string = 'all';
    selectedRating: string = 'all';
    searchQuery: string = '';
    sortBy: string = 'newest';

    // Slider states
    currentReviewSlideIndex: number = 0;
    isReviewDragging: boolean = false;
    reviewTouchStartX: number = 0;
    reviewDragStartX: number = 0;
    reviewDragDeltaX: number = 0;

    // Write review modal
    isWriteReviewModalOpen: boolean = false;
    isSubmittingReview: boolean = false;
    submitSuccessMessage: string = '';

    newReview = {
        name: '',
        email: '',
        service: 'Photobooth',
        rating: 5,
        title: '',
        comment: '',
        avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&auto=format&fit=crop&q=80'
    };

    customerReviews: CustomerReview[] = [
        {
            id: 1,
            name: 'Ryan Almeida',
            avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&auto=format&fit=crop&q=80',
            date: '1 day ago',
            rating: 5,
            title: 'Kualitas Cetak & Layanan Luar Biasa!',
            comment: 'Pelayanan Visidea Studio luar biasa memuaskan! Hasil cetak photobooth super jernih dan tamu-tamu kami di pernikahan sangat senang dengan template kustomnya.',
            service: 'Photobooth',
            verified: true,
            likes: 12
        },
        {
            id: 2,
            name: 'Blossom Menezes',
            avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&auto=format&fit=crop&q=80',
            date: '3 days ago',
            rating: 5,
            title: 'Undangan Elegan & Sangat Responsif',
            comment: 'Undangan digitalnya sangat elegan dan responsif dibuka di smartphone. Musik backsound dan navigasi Google Maps-nya sangat membantu tamu kami.',
            service: 'Digital Invitation',
            verified: true,
            likes: 18
        },
        {
            id: 3,
            name: 'Jason Santoso',
            avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80',
            date: '1 week ago',
            rating: 5,
            title: 'Buku Tamu Digital Sangat Efisien',
            comment: 'Buku tamu digital dengan scan QR code membuat registrasi tamu pernikahan kami tertata sangat rapi dan tanpa antrean panjang. Sangat recommended!',
            service: 'Guest Book',
            verified: true,
            likes: 9
        },
        {
            id: 4,
            name: 'Nadia & Dimas',
            avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&auto=format&fit=crop&q=80',
            date: '1 week ago',
            rating: 5,
            title: '360 Videobooth Jadi Favorit Semua Tamu!',
            comment: '360 Videobooth dari Visidea bener-bener jadi primadona acara resepsi kami! Tim crew-nya sangat ramah, profesional, dan video langsung bisa diunduh tamu via scan QR.',
            service: '360 Videobooth',
            verified: true,
            likes: 24
        },
        {
            id: 5,
            name: 'Kevin Pratama',
            avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80',
            date: '2 weeks ago',
            rating: 5,
            title: 'Paket Bundling Sangat Hemat & Komplit',
            comment: 'Paket bundling Photobooth + Undangan Digital sangat hemat dan praktis. Desain custom-nya persis seperti yang kami impikan. Thank you Visidea Studio!',
            service: 'Bundling Package',
            verified: true,
            likes: 15
        },
        {
            id: 6,
            name: 'Siti Rahmawati',
            avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80',
            date: '2 weeks ago',
            rating: 5,
            title: 'Fitur Amplop Cashless & RSVP Sangat Bagus',
            comment: 'Sangat terbantu dengan fitur amplop cashless QRIS dan RSVP otomatis di undangan digital. Laporannya real-time dan mudah dipantau kapan saja.',
            service: 'Digital Invitation',
            verified: true,
            likes: 11
        },
        {
            id: 7,
            name: 'Budi & Laras',
            avatar: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150&auto=format&fit=crop&q=80',
            date: '3 weeks ago',
            rating: 5,
            title: 'Event Organizer Sangat Profesional & Sigap',
            comment: 'Kerjasama dengan Event Organizer Visidea sangat luar biasa sigap dari awal technical meeting sampai hari-H selesai. Sukses terus untuk Visidea!',
            service: 'Event Organizer',
            verified: true,
            likes: 8
        },
        {
            id: 8,
            name: 'Amanda Vania',
            avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
            date: '1 month ago',
            rating: 5,
            title: 'Vintage Photobooth Aesthetic & Premium',
            comment: 'Hasil foto Vintage Photobooth-nya aesthetic banget, warnanya warm dan kualitas cetak fotonya sangat premium. Tamu undangan banyak yang suka!',
            service: 'Photobooth',
            verified: true,
            likes: 19
        },
        {
            id: 9,
            name: 'Dimas Aditya',
            avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&auto=format&fit=crop&q=80',
            date: '1 month ago',
            rating: 5,
            title: 'Professional Photographer Terbaik di Jakarta',
            comment: 'Hasil dokumentasi foto dan video cinematic dari tim photographer Visidea bener-bener menangkap setiap momen berharga dengan sempurna. Editing-nya sangat elegan!',
            service: 'Professional Photographer',
            verified: true,
            likes: 14
        },
        {
            id: 10,
            name: 'Clara & Felix',
            avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&auto=format&fit=crop&q=80',
            date: '2 months ago',
            rating: 5,
            title: 'Sistem Smart Ticketing Sangat Membantu Acara',
            comment: 'Untuk konser komunitas kami, smart ticketing Visidea mempermudah validasi tiket lewat scanner barcode handphone tanpa hambatan sama sekali. Top markotop!',
            service: 'Smart Ticketing',
            verified: true,
            likes: 7
        }
    ];

    constructor(
        private router: Router
    ) {}

    @HostListener('window:resize')
    onResize() {
        this.updateScreenDimensions();
    }

    private updateScreenDimensions() {
        if (typeof window !== 'undefined') {
            this.screenWidth = window.innerWidth;
        }
    }

    ngOnInit(): void {
        this.updateScreenDimensions();
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }

    // Slider Navigation
    get reviewCardsPerView(): number {
        if (typeof window === 'undefined') return 3;
        if (this.screenWidth < 640) return 1;
        if (this.screenWidth < 1024) return 2;
        return 3;
    }

    get maxReviewSlideIndex(): number {
        return Math.max(0, this.customerReviews.length - this.reviewCardsPerView);
    }

    get reviewProgressPercentage(): number {
        if (this.maxReviewSlideIndex === 0) return 100;
        return Math.min(100, Math.max(15, ((this.currentReviewSlideIndex + 1) / (this.maxReviewSlideIndex + 1)) * 100));
    }

    nextReviewSlide(): void {
        if (this.currentReviewSlideIndex < this.maxReviewSlideIndex) {
            this.currentReviewSlideIndex++;
        } else {
            this.currentReviewSlideIndex = 0;
        }
    }

    prevReviewSlide(): void {
        if (this.currentReviewSlideIndex > 0) {
            this.currentReviewSlideIndex--;
        } else {
            this.currentReviewSlideIndex = this.maxReviewSlideIndex;
        }
    }

    // Touch & Mouse Drag on Slider
    onReviewTouchStart(e: TouchEvent): void {
        if (e.touches && e.touches.length > 0) {
            this.reviewTouchStartX = e.touches[0].clientX;
            this.isReviewDragging = true;
        }
    }

    onReviewTouchMove(e: TouchEvent): void {
        if (!this.isReviewDragging || !e.touches || e.touches.length === 0) return;
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - this.reviewTouchStartX;
        const threshold = 40;
        if (deltaX < -threshold) {
            this.nextReviewSlide();
            this.reviewTouchStartX = currentX;
            this.isReviewDragging = false;
        } else if (deltaX > threshold) {
            this.prevReviewSlide();
            this.reviewTouchStartX = currentX;
            this.isReviewDragging = false;
        }
    }

    onReviewTouchEnd(): void {
        this.isReviewDragging = false;
    }

    onReviewMouseDown(e: MouseEvent): void {
        this.isReviewDragging = true;
        this.reviewDragStartX = e.clientX;
        this.reviewDragDeltaX = 0;
    }

    onReviewMouseMove(e: MouseEvent): void {
        if (!this.isReviewDragging) return;
        this.reviewDragDeltaX = e.clientX - this.reviewDragStartX;
        const threshold = 45;
        if (this.reviewDragDeltaX < -threshold) {
            this.nextReviewSlide();
            this.reviewDragStartX = e.clientX;
            this.reviewDragDeltaX = 0;
            this.isReviewDragging = false;
        } else if (this.reviewDragDeltaX > threshold) {
            this.prevReviewSlide();
            this.reviewDragStartX = e.clientX;
            this.reviewDragDeltaX = 0;
            this.isReviewDragging = false;
        }
    }

    onReviewMouseUp(): void {
        this.isReviewDragging = false;
    }

    // Filtering & Sorting
    setCategory(cat: string): void {
        this.selectedCategory = cat;
    }

    setRating(rating: string): void {
        this.selectedRating = rating;
    }

    scrollToGrid(): void {
        if (typeof document !== 'undefined') {
            const el = document.getElementById('all-reviews-grid');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    get filteredReviews(): CustomerReview[] {
        let result = this.customerReviews.filter(r => {
            // Category filter
            if (this.selectedCategory !== 'all') {
                const s = r.service.toLowerCase();
                if (this.selectedCategory === 'photobooth' && !s.includes('photobooth')) return false;
                if (this.selectedCategory === 'invitation' && !s.includes('invitation')) return false;
                if (this.selectedCategory === 'guestbook' && !s.includes('guest')) return false;
                if (this.selectedCategory === 'videobooth' && !s.includes('videobooth')) return false;
                if (this.selectedCategory === 'eo' && !s.includes('organizer') && !s.includes('eo')) return false;
            }

            // Rating filter
            if (this.selectedRating !== 'all') {
                if (r.rating !== parseInt(this.selectedRating, 10)) return false;
            }

            // Search query
            if (this.searchQuery.trim()) {
                const q = this.searchQuery.toLowerCase().trim();
                const matchName = r.name.toLowerCase().includes(q);
                const matchComment = r.comment.toLowerCase().includes(q);
                const matchService = r.service.toLowerCase().includes(q);
                const matchTitle = (r.title || '').toLowerCase().includes(q);
                if (!matchName && !matchComment && !matchService && !matchTitle) return false;
            }

            return true;
        });

        // Sort
        if (this.sortBy === 'highest') {
            result.sort((a, b) => b.rating - a.rating);
        } else if (this.sortBy === 'likes') {
            result.sort((a, b) => (b.likes || 0) - (a.likes || 0));
        }

        return result;
    }

    // Like Review
    toggleLike(review: CustomerReview): void {
        if (review.hasLiked) {
            review.likes = (review.likes || 1) - 1;
            review.hasLiked = false;
        } else {
            review.likes = (review.likes || 0) + 1;
            review.hasLiked = true;
        }
    }

    // Write review modal
    openWriteReviewModal(): void {
        this.submitSuccessMessage = '';
        this.isWriteReviewModalOpen = true;
    }

    closeWriteReviewModal(): void {
        this.isWriteReviewModalOpen = false;
    }

    setNewReviewRating(stars: number): void {
        this.newReview.rating = stars;
    }

    submitNewReview(): void {
        if (!this.newReview.name || !this.newReview.comment) {
            return;
        }

        this.isSubmittingReview = true;

        setTimeout(() => {
            const created: CustomerReview = {
                id: Date.now(),
                name: this.newReview.name,
                avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(this.newReview.name)}&background=35cfa6&color=163861&bold=true`,
                date: 'Just now',
                rating: this.newReview.rating,
                title: this.newReview.title || 'Review Pelanggan Visidea',
                comment: this.newReview.comment,
                service: this.newReview.service,
                verified: true,
                likes: 1
            };

            this.customerReviews.unshift(created);
            this.isSubmittingReview = false;
            this.submitSuccessMessage = 'Terima kasih atas ulasan Anda! Review Anda telah berhasil dipublikasikan.';

            // Reset form
            this.newReview = {
                name: '',
                email: '',
                service: 'Photobooth',
                rating: 5,
                title: '',
                comment: '',
                avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&auto=format&fit=crop&q=80'
            };

            setTimeout(() => {
                this.closeWriteReviewModal();
            }, 1800);
        }, 600);
    }

    // Navigations
    goToHome(): void {
        this.router.navigate(['/']);
    }

    goToPackages(): void {
        this.router.navigate(['/package']);
    }
}
